import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { BANK_LOGO_URL } from 'api/index';
import GenericBankLogo from 'assets/imgs/genericBankLogo.svg';

type Props = {
  bankName: String,
};

const BankLogo = (props: Props) => {
  const { bankName } = props;
  const [imageFetchError, setImageFetchError] = useState(false);
  const DefaultBankLogo = (
    <>
      <Tooltip title={bankName}>
        <div style={{
          position: 'relative',
          display: 'inline-block',
          textAlign: 'center',
        }}
        >
          <img
            src={GenericBankLogo}
            alt="bank logo"
            style={{
              minHeight: '30px',
              minWidht: '60px',
              maxHeight: '30px',
              maxWidth: '60px',
            }}
          />
          <div style={{
            position: 'absolute',
            top: '70%',
            left: '0%',
            fontSize: '7px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: '25%',
            width: '100%',
            fontWeight: 'bold',
            color: 'white',
            textShadow: '-2px -2px 0 black, 2px -2px 0 black, -2px  2px 0 black, 2px  2px 0 black;',
            textAlign: 'center',
          }}
          >
            {bankName}
          </div>
        </div>
      </Tooltip>
    </>
  );
  const BankSpecificLogo = (
    <>
      <Tooltip title={bankName}>
        <img
          src={`${BANK_LOGO_URL}/${encodeURIComponent(bankName)}.webp`}
          alt="bank logo"
          style={{
            display: 'inline-block',
            height: 'auto',
            width: 'auto',
            minHeight: '20px',
            minWidth: '45px',
            maxHeight: '25px',
            maxWidth: '60px',
            paddingRight: '10px',
          }}
          onError={(e) => {
            e.target.onerror = null;
            setImageFetchError(true);
          }}
        />
      </Tooltip>
    </>
  );
  if (imageFetchError) {
    return DefaultBankLogo;
  }
  return BankSpecificLogo;
};

export default BankLogo;
